<template>
  <div class="container row">
    <div class="col-md-6">
      <b-overlay>
        <section class="ftco-section">
          <div class="d-flex justify-content-center">
            <img
              src="@/assets/site/images/loader.gif"
              v-if="loader === true"
              class="img-fluid loader-width"
              alt
            />
          </div>
          <div class="container" v-if="!loader">
            <div class="flex-lg-row flex-md-row">
              <div style="margin-top: 2rem">
                <div class="card-body bg-dark-gray">
                  <h2 class="text-black">Profile</h2>
                  <form>
                    <div class="form-group">
                      <input
                        type="text"
                        class="form-control"
                        v-model="username"
                        placeholder="User Name*"
                      />
                      <span class="text-danger" v-if="errors.username">{{
                        this.errors.username[0]
                      }}</span>
                    </div>
                    <div class="form-group">
                      <input
                        type="text"
                        class="form-control"
                        v-model="userData.name"
                        placeholder="Name*"
                      />
                      <span class="text-danger" v-if="errors.name">{{
                        this.errors.name[0]
                      }}</span>
                    </div>
                    <div class="form-group">
                      <input
                        type="email"
                        class="form-control"
                        v-model="userData.email"
                        placeholder="Email Address*"
                        :readonly="userData.email != null"
                      />
                      <span class="text-danger" v-if="errors.email">{{
                        this.errors.email[0]
                      }}</span>
                    </div>
                    <div class="form-group">
                      <div class="row">
                        <div class="col-md-2 pr-0">
                          <vue-country-code
                            @onSelect="onSelect"
                            :defaultCountry="country"
                            disabledFetchingCountry
                            enabledCountryCode
                            enabledFlags
                          >
                          </vue-country-code>
                        </div>
                        <div class="col-md-10 pl-0">
                          <input
                            type="text"
                            class="form-control"
                            v-model="mobile"
                            placeholder="Mobile*"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <b-form-group class="font-weight-600">
                        <label class="font-weight-600 mb-3">Gender</label>
                        <div class="row">
                          <div class="col-md-3">
                            <b-form-radio
                              size="lg"
                              class="radio-control"
                              v-model="gender"
                              name="gender"
                              value="Male"
                              >Male</b-form-radio
                            >
                          </div>
                          <div class="col-md-3">
                            <b-form-radio
                              size="lg"
                              class="radio-control"
                              v-model="gender"
                              name="gender"
                              value="Female"
                              >Female</b-form-radio
                            >
                          </div>
                          <span class="text-danger" v-if="errors.gender">{{
                            this.errors.gender[0]
                          }}</span>
                        </div>
                      </b-form-group>
                    </div>
                    <div class="row mb-1">
                      <div class="mt-4 mb-2 ml-3">
                        <button
                          @click="UpdateProfile"
                          type="button"
                          class="btn btn-primary btn-block px-4"
                        >
                          Update
                        </button>
                      </div>
                      <div class="mt-4 mb-2 ml-3">
                        <button
                          @click="deleteAccount()"
                          type="button"
                          class="btn btn-primary btn-block px-4"
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </b-overlay>
    </div>
    <div class="image-container col-md-3">
      <h2>PERSONA</h2>
      <div class="image-wrapper">
        <div v-for="persona in personaImages" class="image-container">
          <img :src="persona.src" class="img-fluid" :alt="persona.alt" />
          <span>{{ persona.alt }}</span>
        </div>
      </div>
    </div>
    <div class="image-container col-md-3">
      <h2>ACTIVE LIFESTYLE</h2>
      <div class="image-wrapper">
        <div v-for="lifestyle in lifestyleImages" class="image-container">
          <img :src="lifestyle.src" class="img-fluid" :alt="lifestyle.alt" />
          <span>{{ lifestyle.alt }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import VueCountryCode from "vue-country-code";

Vue.use(VueCountryCode);
export default {
  name: "EditMyPageView",
  metaInfo: {
    title: "Edit My Page",
    meta: [
      {
        name: "description",
        content:
          "Customize your experience on Edit My Page! Easily modify your interests, preferences, and product selections to ensure a personalized shopping journey tailored just for you.",
      },
      {
        name: "keywords",
        content:
          "edit preferences, customize page, modify interests, personalized shopping, update selections, user preferences, tailored experience",
      },
    ],
  },
  data() {
    return {
      userData: [],
      errors: [],
      loader: false,
      gender: "",
      enabledCountryCode: true,
      enabledFlags: false,
      countrycode: "",
      country: "",
      name: "",
      user: null,
      hasProfile: true,
      modal_id: null,
      userId: null,
      trendingProducts: [],
      wizardData: null,
      personaImages: [],
      lifestyleImages: [],
    };
  },
  created() {
    this.getProfile();
    this.setUserDatas();
  },
  methods: {
    getPersonas() {
      const fetch_url =
        process.env.VUE_APP_URL + "customer/persona/getPersonas";
      fetch(fetch_url, {
        method: "post",
        headers: {
          "content-type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          gender: this.gender,
          type: this.wizardData.ageGroup,
          ch_type: "persona",
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          this.loader = false;
          const personas = data.caricatures.filter((caricature) =>
            this.wizardData.persona.includes(caricature.id)
          );
          const imageArray = [];

          personas.forEach(function(persona) {
            imageArray.push({
              id: persona.id,
              src: persona.icon_persona,
              alt: persona.name,
            });
          });
          this.personaImages = imageArray;
        })
        .catch(function(err) {
          console.log("Fetch Error :-S", err);
        });
    },
    getLifestyles() {
      const fetch_url =
        process.env.VUE_APP_URL + "customer/persona/getPersonas";
      fetch(fetch_url, {
        method: "post",
        headers: {
          "content-type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          gender: this.gender,
          type: this.wizardData.ageGroup,
          ch_type: "active_lifestyle",
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          this.loader = false;
          const styles = data.caricatures.filter((caricature) =>
            this.wizardData.activeLifeStyle.includes(caricature.id)
          );

          const img_array = [];

          styles.forEach(function(style) {
            img_array.push({
              id: style.id,
              src: style.icon_style,
              alt: style.name,
            });
          });
          this.lifestyleImages = img_array;
        })
        .catch(function(err) {
          console.log("Fetch Error :-S", err);
        });
    },
    getProfile() {
      this.errors = [];
      const token = JSON.parse(localStorage.getItem("userData"));
      const user_id = token.user.id;
      let method_type = "";
      let fetch_url = "";
      method_type = "post";
      fetch_url = process.env.VUE_APP_URL + "customer/GetCustomerData";
      fetch(fetch_url, {
        method: method_type,
        headers: {
          "content-type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          customer_id: user_id,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          this.loader = false;
          this.errors = [];
          this.wizardData = JSON.parse(data.data.wizard_details);
          this.userId = data.data.id;
          this.getPersonas();
          this.getLifestyles();
        });
    },
    onSelect({ iso2, dialCode }) {
      this.countrycode = dialCode;
      this.country = iso2;
    },
    setUserDatas() {
      const loc_UserData = localStorage.getItem("userData");
      const { user } = JSON.parse(loc_UserData);

      this.userData = user;
      this.country = user.country;
      this.countrycode = user.country_code;
      this.gender = user.gender;
      this.mobile = user.mobile;
      this.username = user.name;
    },
    UpdateProfile() {
      //Save or update User Details
      this.errors = [];

      let apiUrl =
        process.env.VUE_APP_URL + "customer/UpdateProfile/" + this.userData.id;
      let method_type = "post";
      fetch(apiUrl, {
        method: method_type,
        headers: {
          "content-type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          name: this.userData.name,
          username: this.username,
          gender: this.gender,
          email: this.userData.email,
          mobile: this.mobile,
          country_code: this.countrycode,
          country: this.country,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status === 200) {
            this.loader = false;
            this.$swal.fire("Good to Go", data.message, "success");
            // this.resetForm();

            var userData = {
              user: data.customer,
              // token: data.token,
              status: true,
            };
            localStorage.setItem("userData", JSON.stringify(userData));
          }
          if (data.status === false) {
            this.$swal("Error", data.message, "error");
          } else {
            this.loader = false;
            this.errors = data.errors;
          }
        })
        .catch(function(err) {
          console.log("Profile ", "Error : " + err.message, "error");
        });
    },
    deleteAccount() {
      // this.loader = true;
      var token = localStorage.getItem("userData");
      var userdata_array = JSON.parse(token);
      var api_token = userdata_array.token;
      var user_id = userdata_array.user.id;
      this.$swal
        .fire({
          title: "Are you sure?",
          text:
            "Do you want to remove Account " + userdata_array.user.name + "!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        })
        .then((result) => {
          if (result.value) {
            fetch(process.env.VUE_APP_URL + "customer/deleteAccount", {
              method: "post",
              headers: {
                "content-type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
                Authorization: "Bearer " + api_token,
              },

              body: JSON.stringify({
                user_id: user_id,
              }),
            })
              .then((res) => res.json())
              .then((data) => {
                if (data.status === true) {
                  this.loader = false;
                  localStorage.clear();
                  window.location.href = "/";
                  this.$swal.fire("Deleted", data.message, "success");
                } else {
                  this.loader = false;
                  this.$swal.fire("Error!", data.message, "error");
                }
              })
              .catch(function(err) {
                console.log("Fetch Error :-S", err);
              });
          }
        });
    },
    resetForm() {
      this.name = null;
      this.username = null;
      this.gender = null;
      this.email = null;
      this.mobile = null;
      this.errors = [];
    },
  },
};
</script>
<style>
.image-container {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.image-wrapper .image-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.image-wrapper .image-container img {
  width: 200px;
  height: auto;
  object-fit: cover;
  border-radius: 8px;
}

.image-wrapper .image-container span {
  font-weight: 500;
  font-size: 20px;
}
</style>
